import React from "react";

const InvoiceHeader = ({ invoiceNumber, companyDetails, currentDate, dueDate, currency }) => {
  return (
    <div className="flex flex-col gap-4 border-b pb-4 mb-4">
      {/* Company Info */}
      <div className="flex items-start gap-3">
        {/* Logo */}
        {companyDetails?.company_logo && (
          <div className="w-12 h-12 flex-shrink-0">
            <img
              src={companyDetails.company_logo}
              alt="Company Logo"
              className="w-full h-full object-contain"
            />
          </div>
        )}
        {/* Details */}
        <div className="flex-1 min-w-0">
          <h2 className="text-lg font-bold  truncate" title={companyDetails?.company_name}>
            {companyDetails?.company_name || "Company Name"}
          </h2>
          <p className="text-gray-500 text-xs truncate" title={companyDetails?.company_address}>
            {companyDetails?.company_address || "Company Address"}
          </p>
          {companyDetails?.reg_number && (
            <p className="text-gray-500 text-xs truncate" title={companyDetails?.reg_number}>
              {companyDetails?.reg_number || "Company Registration Number"}
            </p>
          )}
        </div>
      </div>

      {/* Invoice Info */}
      <div className="text-center">
        <h1 className="text-xl font-extrabold text-gray-900">INVOICE</h1>
        <div className="mt-2 text-xs text-gray-600 space-y-1">
          <p className="truncate">
            <span className="font-semibold">Number:</span> {invoiceNumber}
          </p>
          <p>
            <span className="font-semibold">Date:</span> {currentDate}
          </p>
          <p>
            <span className="font-semibold">Due:</span> {dueDate}
          </p>
          {currency && (
            <p>
              <span className="font-semibold">Currency:</span> {currency}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InvoiceHeader;